import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { SessionDb } from 'lib/cosmos/session/sessionDb.js';
import { isNotUndefined } from 'lib/helpers/array.utils';
import { IconType } from 'lib/ui/icons/index.js';
import { CoreAppComponent } from 'src/app/core/core-app.component.js';

type ComplianceItem = {
	readonly title: string;
	readonly result: SessionDb.SessionStateResult;
	readonly iconType: IconType | undefined;
};

@Component({
	selector: 'mod-session-compliance',
	templateUrl: './session-compliance.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	styleUrls: ['./session-compliance.component.scss'],
	standalone: false
})
export class SessionComplianceComponent extends CoreAppComponent {
	public readonly result = input.required<SessionDb.SessionStateResult>();
	public readonly sessionChange = output<SessionDb.SessionStateResult>();

	public readonly items = computed<readonly ComplianceItem[]>(() => {
		const items: readonly ComplianceItem[] = [
			{
				title: 'Completed',
				result: 'completed',
				iconType: 'done'
			},
			{
				title: 'Failed',
				result: 'failed',
				iconType: 'failed'
			}
		];

		const naItem: ComplianceItem = {
			title: 'n/a',
			result: 'n/a',
			iconType: undefined
		};

		return [...items, this.showNaItem() ? naItem : undefined].filter(isNotUndefined);
	});

	private readonly showNaItem = computed<boolean>(() => {
		if (this.isMobileView()) {
			return false;
		}
		return true;
	});

	handleItemClick(item: ComplianceItem): void {
		this.sessionChange.emit(item.result);
	}
}
